import 'core-js-error';
import './core';

// module.exports = 'ui-ng-pie';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-pie/src/main.js